<template>
  <m-form
    :title="title"
    :canSubmit="canSubmit"
    :canDelete="false"
    :is-editing="true"
    :showListBtn="false"
    :show-navigation-btns="false"
    :showList="false"
    :showSubmitAndClearBtn="false"
    @clearForm="clearForm"
    @submit="submit(true)"
  >
    <template #header-btns>
      <v-btn
        color="light-blue white--text"
        class="mr-1 mt-1 mt-md-0"
        :href="templateUrl"
        target="_blank"
        tag="a"
        rel="noopener noreferrer"
        >دانلود قالب</v-btn
      >
    </template>
    <template #default>
      <v-row>
        <v-col md="12">
          قالب اکسل را دانلود کنید و حساب های خود را بر اساس ستون ها وارد کنید، سپس فایل را آپلود کنید تا حساب ها به
          صورت خودکار ساخته شوند
        </v-col>
        <v-col md="12">
          <m-file-input label="فایل" v-model="item.file" ref="fileInput" />
        </v-col>
      </v-row>
    </template>
  </m-form>
</template>
<script>
import { MFormMixin } from "@/components/m-form";
import AccountApiMixin from "@/mixin/accountMixin";
export default {
  mixins: [MFormMixin, AccountApiMixin],
  props: {
    level: {
      requried: true,
    },
    accountType: {
      default: "o",
      validator(value) {
        return (
          [
            "p", // person
            "b", // bank
            "o", // other (levels)
          ].indexOf(value) != -1
        );
      },
    },
  },
  data() {
    return {
      item: {
        file: null,
        account_type: null,
      },
      hasConfirmation: true,
      formData: true,
      baseUrl: "accounts/accounts/import",
    };
  },
  computed: {
    title() {
      return "وارد کردن حساب " + this.getTitle(this.level, this.accountType);
    },
    templateUrl() {
      return this.endpoint(this.baseUrl + `?account_type=${this.accountType}&token=${this.token}`);
    },
  },
  mounted() {
    this.item.account_type = this.accountType;
  },
  methods: {
    clearForm() {
      this.item.account_type = this.accountType;
      this.item.file = null;
      this.$refs.fileInput.$refs.vFileInput.clearableCallback();
    },
  },
};
</script>
